import api from "@/vue-dlb/utils/backend-api";
import ObjDataSet from "@/vue-dlb/models/objdataset";
import ObjTrSet from "@/vue-dlb/models/objtrset";
import {UploadFile} from '@/vue-dlb/models'
import appUtil from '@/vue-dlb/utils/app-util'
import config from '@/vue-caas/config/config.js';

import {
  commitRetDataSets
} from "@/vue-dlb/utils/sys-util.js";

import {
  selectDataSetByDataSet,
  execSPByDataSet,
  callByDataSet,
} from "@/vue-dlb/utils/backend-util.js";

import $ from 'jquery';
import { get } from "lodash";

const isDlbMybatis = config.isDlbMybatis;

const state = {
  srmList: [],
  repoList: [],
  allRepoList: [],
  repoListSource: [],
  arrRepoFilter: [],
  mainGrid: [],
  arrFilter: [],
  mainGridSource: [],
  srmListSource:[],
  segItems: [],
  mergeViewItems: [],
  mergeViewItemsSource: [],
  selectMergeViewItems: [],
  mergeViewItemsSearch: [],
  totalCnt: [],
};

const getters = {
};

const actions = {
  /*
  203665 Update pagination for SRM list repository manager issue 35
  */
  querySRMList: async ({ commit }, searchItems) => {
    const retSet1 = new ObjDataSet("srmList");
    const retSet2 = new ObjDataSet("totalCnt");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("querySRMList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet1);
    trSet.AddDataSet("O", "DS03", retSet2);
    trSet.tranID = "DS02:EDP_REPO_LIST_SRM_MST_FN|DS03:EDP_REPO_LIST_SRM_MST_TOTAL_FN"
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  queryRepoList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("repoList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryRepoList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_REPO_LIST_REPO_SRM_MST_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  queryAllRepoList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("allRepoList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryRepoList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_REPO_LIST_REPO_SRM_MST_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  queryList: async ({ commit }, searchItems) => {
    const retSet1 = new ObjDataSet("mainGrid");
    const retSet2 = new ObjDataSet("statusList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet1);
    trSet.AddDataSet("O", "DS03", retSet2);
    trSet.tranID = "DS02:EDP_SRM_LIST_MAN_SRM_MST_FN|DS03:EDP_SRM_LIST_MAN_SRM_STATUS_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  saveList: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("saveRepoSRMList");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    let reqdata = ''
    if (isDlbMybatis) {
      trSet.tranID = "RepositoryManager";
      trSet.tranMethod = "saveList";
      reqdata = callByDataSet(trSet);
    } else {
      trSet.tranID = "EDP_REPO_UPD_REPO_SRM_MST_SP";
      trSet.suiParam = "USER_IDNO";
      reqdata = execSPByDataSet(trSet);
    }
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  copyToRepository: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("copyToRepository");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    let reqdata = ''
    if (isDlbMybatis) {
      trSet.tranID = "RepositoryManager";
      trSet.tranMethod = "copyToRepository";
      reqdata = callByDataSet(trSet);
    } else {
      trSet.tranID = "EDP_REPO_INS_SRM_COPY_TO_REPO_SP";
      trSet.suiParam = "USER_IDNO";
      reqdata = execSPByDataSet(trSet);
    }    
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  saveRepository: async ({ commit }, paramItems) => {
    const retSet = new ObjDataSet("retSet");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("saveRepository");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "RepositoryManager";
    trSet.tranMethod = "saveRepository";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  deleteRepository: async ({ commit }, paramItems) => {
    const retSet = new ObjDataSet("retSet");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("deleteRepository");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "RepositoryManager";
    trSet.tranMethod = "deleteRepository";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  selectMergeCreatedLayout: async ({ commit }, searchItems) => {
    const retSet1 = new ObjDataSet("segItems");
    const retSet2 = new ObjDataSet("mergeViewItems");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("selectMergeCreatedLayout");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet1);
    trSet.AddDataSet("O", "DS03", retSet2);
    trSet.tranID = "RepositoryManager";
    trSet.tranMethod = "selectMergeCreatedLayout";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    })
  },
  layoutMergeSave: async ({ commit }, insertPayload) => {
    let insertMaster = insertPayload[0];
    let insertData = insertPayload[1];
    const retSet = new ObjDataSet("rtnPrcsNo");
    let condSet1 = new ObjDataSet("condSet1");
    let condSet2 = new ObjDataSet("condSet2");
    const trSet = new ObjTrSet("layoutMergeSave");
    condSet1 = appUtil.addDataHeader(insertMaster, condSet1);
    condSet2 = appUtil.addDataHeader(insertData, condSet2);
    trSet.AddDataSet("I", "DS01", condSet1);
    trSet.AddDataSet("I", "DS02", condSet2);
    trSet.AddDataSet("O", "DS03", retSet);
    trSet.tranID = "RepositoryManager";
    trSet.tranMethod = "layoutMergeSave";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  setFilterMergeCompare: async ({ commit }, filter) => {
    commit('SET_STORE_SEARCH_MERGE_COMPARE_FILTER', filter);
  },
  setFilter: async ({ commit }, filter) => {
    commit('SET_STORE_TOGGLE_MERGE_COMPARE_FILTER', filter);
  },
};

const mutations = {
  segItems (state, datarows) {
    state.segItems = [];
    state.segItems = datarows;
  },
  totalCnt (state, datarows) {
    state.totalCnt = datarows[0].TOTAL;
  },
  mergeViewItems (state, datarows) {
    for (let i = 0; i < datarows.length; i++) {
      let item = datarows[i];
      if (datarows[i].SELE_YN == 'Y') {
        item._checked = true;
        state.selectMergeViewItems.push(item);
      }
    }
    state.mergeViewItems = datarows;
    state.mergeViewItemsSource = datarows;
  },
  srmList (state, datarows) {
    state.srmList = [];
    datarows = datarows.sort((a ,b) => {
      let propa = a.LAY_PRCS_NO;
      let propb = b.LAY_PRCS_NO;
      if (propa > propb) {
        return 1;
      } else if (propa < propb) {
        return -1;
      }
      return 0;
    });
    let arrFilter = [];
    for (let i = 0; i < datarows.length; i++) {
      let rowitem = datarows[i];
      if (rowitem.LAY_PRCS_NO == null) {
        continue;
      }
      let filters = arrFilter.filter((item) => {
        return item.LAY_PRCS_NO == rowitem.LAY_PRCS_NO;
      });
      if (filters.length == 1) {
        let item = filters[0];
        item.count = item.count + 1;
      } else {
        let obj = Object.assign({}, rowitem);
        arrFilter.push({
          index : i,
          LAY_PRCS_NO : obj.LAY_PRCS_NO,
          count : 1
        })
      }
    }
    state.srmList = datarows;
    state.srmListSource = datarows;
    state.arrFilter = arrFilter;
  },
  srmListFilter (state, datarows) {
    let data = [];
    for (let i = 0; i < datarows.length; i++) {
      let item = datarows[i];
      if (!item.hidden) {
        data.push(item);
      }
    }
    datarows = data;

    datarows = datarows.sort((a ,b) => {
      let propa = a.LAY_PRCS_NO;
      let propb = b.LAY_PRCS_NO;
      if (propa > propb) {
        return 1;
      } else if (propa < propb) {
        return -1;
      }
      return 0;
    });
    let arrFilter = [];
    for (let i = 0; i < datarows.length; i++) {
      let rowitem = datarows[i];
      if (rowitem.LAY_PRCS_NO == null) {
        continue;
      }
      let filters = arrFilter.filter((item) => {
        return item.LAY_PRCS_NO == rowitem.LAY_PRCS_NO;
      });
      if (filters.length == 1) {
        let item = filters[0];
        item.count = item.count + 1;
      } else {
        let obj = Object.assign({}, rowitem);
        arrFilter.push({
          index : i,
          LAY_PRCS_NO : obj.LAY_PRCS_NO,
          count : 1
        })
      }
    }
    state.arrFilter = arrFilter;
    state.srmList = datarows;
  },
  allRepoList(state, datarows){
    state.allRepoList = [];
    state.allRepoList = datarows;
  },
  repoList (state, datarows) {
    state.repoList = [];
    datarows = datarows.sort((a ,b) => {
      let propa = a.LAY_PRCS_NO;
      let propb = b.LAY_PRCS_NO;
      if (propa > propb) {
        return 1;
      } else if (propa < propb) {
        return -1;
      }
      return 0;
    });
    let arrFilter = [];
    for (let i = 0; i < datarows.length; i++) {
      let rowitem = datarows[i];
      rowitem.CUSTOMER = rowitem.SRM_SNDR;
      if (rowitem.LAY_PRCS_NO == null) {
        continue;
      }
      let filters = arrFilter.filter((item) => {
        return item.LAY_PRCS_NO == rowitem.LAY_PRCS_NO;
      });
      if (filters.length == 1) {
        let item = filters[0];
        item.count = item.count + 1;
      } else {
        let obj = Object.assign({}, rowitem);
        arrFilter.push({
          index : i,
          LAY_PRCS_NO : obj.LAY_PRCS_NO,
          count : 1
        })
      }
    }
    state.repoList = datarows;
    state.repoListSource = datarows;
    state.arrRepoFilter = arrFilter;
  },
  repoListFilter (state, datarows) {
    let data = [];
    for (let i = 0; i < datarows.length; i++) {
      let item = datarows[i];
      if (!item.hidden) {
        data.push(item);
      }
    }
    datarows = data;

    datarows = datarows.sort((a ,b) => {
      let propa = a.LAY_PRCS_NO;
      let propb = b.LAY_PRCS_NO;
      if (propa > propb) {
        return 1;
      } else if (propa < propb) {
        return -1;
      }
      return 0;
    });
    let arrFilter = [];
    for (let i = 0; i < datarows.length; i++) {
      let rowitem = datarows[i];
      if (rowitem.LAY_PRCS_NO == null) {
        continue;
      }
      let filters = arrFilter.filter((item) => {
        return item.LAY_PRCS_NO == rowitem.LAY_PRCS_NO;
      });
      if (filters.length == 1) {
        let item = filters[0];
        item.count = item.count + 1;
      } else {
        let obj = Object.assign({}, rowitem);
        arrFilter.push({
          index : i,
          LAY_PRCS_NO : obj.LAY_PRCS_NO,
          count : 1
        })
      }
    }
    state.arrRepoFilter = arrFilter;
    state.repoList = datarows;
  },
  mainGrid (state, datarows) {
    datarows = datarows.sort((a ,b) => {
      let propa = a.LAY_PRCS_NO;
      let propb = b.LAY_PRCS_NO;
      if (propa > propb) {
        return 1;
      } else if (propa < propb) {
        return -1;
      }
      return 0;
    });
    let arrFilter = [];
    for (let i = 0; i < datarows.length; i++) {
      let rowitem = datarows[i];
      rowitem.CUSTOMER = rowitem.SRM_SNDR;
      if (rowitem.LAY_PRCS_NO == null) {
        continue;
      }
      let filters = arrFilter.filter((item) => {
        return item.LAY_PRCS_NO == rowitem.LAY_PRCS_NO;
      });
      if (filters.length == 1) {
        let item = filters[0];
        item.count = item.count + 1;
      } else {
        let obj = Object.assign({}, rowitem);
        arrFilter.push({
          index : i,
          LAY_PRCS_NO : obj.LAY_PRCS_NO,
          count : 1
        })
      }
    }
    state.mainGrid = datarows;
    state.mainGridSource = datarows;
    state.arrFilter = arrFilter;
  },
  mainGridFilter (state, datarows) {
    let data = [];
    for (let i = 0; i < datarows.length; i++) {
      let item = datarows[i];
      if (!item.hidden) {
        data.push(item);
      }
    }
    datarows = data;

    datarows = datarows.sort((a ,b) => {
      let propa = a.LAY_PRCS_NO;
      let propb = b.LAY_PRCS_NO;
      if (propa > propb) {
        return 1;
      } else if (propa < propb) {
        return -1;
      }
      return 0;
    });
    let arrFilter = [];
    for (let i = 0; i < datarows.length; i++) {
      let rowitem = datarows[i];
      if (rowitem.LAY_PRCS_NO == null) {
        continue;
      }
      let filters = arrFilter.filter((item) => {
        return item.LAY_PRCS_NO == rowitem.LAY_PRCS_NO;
      });
      if (filters.length == 1) {
        let item = filters[0];
        item.count = item.count + 1;
      } else {
        let obj = Object.assign({}, rowitem);
        arrFilter.push({
          index : i,
          LAY_PRCS_NO : obj.LAY_PRCS_NO,
          count : 1
        })
      }
    }
    state.arrFilter = arrFilter;
    state.mainGrid = datarows;
  },
  sortRepoList (state, data) {
    let datarows = state.repoList;
    let arrFilter = [];
    for (let i = 0; i < datarows.length; i++) {
      let rowitem = datarows[i];
      let filters = arrFilter.filter((item) => {
        return item.LAY_PRCS_NO == rowitem.LAY_PRCS_NO;
      });
      if (filters.length == 1) {
        let item = filters[0];
        item.data.push(rowitem);
      } else {
        let obj = Object.assign({}, rowitem);
        arrFilter.push({
          index : i,
          LAY_PRCS_NO : obj.LAY_PRCS_NO,
          data : [rowitem]
        })
      }
    }

    let {col, sort} = data;
    if (sort == '') {
      state.arrRepoFilter = [];
      state.repoList = state.repoListSource;
      return;
    }

    for (let i = 0; i < arrFilter.length; i++) {
      let filter = arrFilter[i];
      let data = filter.data;
      data.sort((a ,b) => {
        let propa = a[col];
        let propb = b[col];
        if (propa > propb) {
          if (sort == 'asc') {
            return 1;
          }
          return -1;
        } else if (propa < propb) {
          if (sort == 'asc') {
            return -1;
          }
          return 1;
        }
        return 0;
      });
    }

    arrFilter.sort((a ,b) => {
      let itema = a.data[0];
      let itemb = b.data[0];
      let propa = itema[col];
      let propb = itemb[col];
      if (propa > propb) {
        if (sort == 'asc') {
          return 1;
        }
        return -1;
      } else if (propa < propb) {
        if (sort == 'asc') {
          return -1;
        }
        return 1;
      }
      return 0;
    });

    let sortdata = [];

    for(let i = 0; i < arrFilter.length; i++)  {
      sortdata = sortdata.concat(arrFilter[i].data);
    }

    let repoFilter = [];
    for (let i = 0; i < sortdata.length; i++) {
      let rowitem = sortdata[i];
      if (rowitem.LAY_PRCS_NO == null) {
        continue;
      }
      let filters = repoFilter.filter((item) => {
        return item.LAY_PRCS_NO == rowitem.LAY_PRCS_NO;
      });
      if (filters.length == 1) {
        let item = filters[0];
        item.count = item.count + 1;
      } else {
        let obj = Object.assign({}, rowitem);
        repoFilter.push({
          index : i,
          LAY_PRCS_NO : obj.LAY_PRCS_NO,
          count : 1
        })
      }
    }

    state.arrRepoFilter = repoFilter;
    state.repoList = sortdata;
  },
  sortSRMList (state, data) {
    let datarows = state.srmList;
    let arrSrmFilter = [];
    for (let i = 0; i < datarows.length; i++) {
      let rowitem = datarows[i];
      let filters = arrSrmFilter.filter((item) => {
        return item.LAY_PRCS_NO == rowitem.LAY_PRCS_NO;
      });
      if (filters.length == 1) {
        let item = filters[0];
        item.data.push(rowitem);
      } else {
        let obj = Object.assign({}, rowitem);
        arrSrmFilter.push({
          index : i,
          LAY_PRCS_NO : obj.LAY_PRCS_NO,
          data : [rowitem]
        })
      }
    }

    let {col, sort} = data;
    if (sort == '') {
      state.arrFilter = [];
      state.srmList = state.srmListSource;
      return;
    }

    for (let i = 0; i < arrSrmFilter.length; i++) {
      let filter = arrSrmFilter[i];
      let data = filter.data;
      data.sort((a ,b) => {
        let propa = a[col];
        let propb = b[col];
        if (propa > propb) {
          if (sort == 'asc') {
            return 1;
          }
          return -1;
        } else if (propa < propb) {
          if (sort == 'asc') {
            return -1;
          }
          return 1;
        }
        return 0;
      });
    }

    arrSrmFilter.sort((a ,b) => {
      let itema = a.data[0];
      let itemb = b.data[0];
      let propa = itema[col];
      let propb = itemb[col];
      if (propa > propb) {
        if (sort == 'asc') {
          return 1;
        }
        return -1;
      } else if (propa < propb) {
        if (sort == 'asc') {
          return -1;
        }
        return 1;
      }
      return 0;
    });

    let sortdata = [];

    for(let i = 0; i < arrSrmFilter.length; i++)  {
      sortdata = sortdata.concat(arrSrmFilter[i].data);
    }

    let repoSrmFilter = [];
    for (let i = 0; i < sortdata.length; i++) {
      let rowitem = sortdata[i];
      if (rowitem.LAY_PRCS_NO == null) {
        continue;
      }
      let filters = repoSrmFilter.filter((item) => {
        return item.LAY_PRCS_NO == rowitem.LAY_PRCS_NO;
      });
      if (filters.length == 1) {
        let item = filters[0];
        item.count = item.count + 1;
      } else {
        let obj = Object.assign({}, rowitem);
        repoSrmFilter.push({
          index : i,
          LAY_PRCS_NO : obj.LAY_PRCS_NO,
          count : 1
        })
      }
    }

    state.arrFilter = repoSrmFilter;
    state.srmList = sortdata;
  },
  'SET_STORE_SEARCH_MERGE_COMPARE_FILTER' (state, filter) {
    let datarows = state.mergeViewItemsSource;
    state.filter = filter;
    let query = filter.query;
    let listResult = [];
    let query_not_used = filter.filterQuery.not_used;
    let query_qualifier = filter.filterQuery.qualifier;
    // let query_one_value = filter.filterQuery.one_value;
    if ( query_not_used || query_qualifier) {
      datarows = state.mergeViewItemsSource;
    }
    if (!query_not_used && !query_qualifier) {
      datarows = datarows.filter(item =>  {
          if(item.ELEM_VAL != null){
            if(item.ELEM_VAL.toLowerCase() != "not used"){
              return true;
            }
          }
          return false;
        });
    }
    if (query.trim() == '') {
      listResult = datarows;
    }
    listResult = datarows.filter(item =>  {
      for (const prop in item) {
        if (typeof item[prop] == 'string') {
          let propValue = item[prop].toLowerCase();
          let queryValue = query.toLowerCase();
          if (propValue.startsWith(queryValue)) {
            return true;
          }
        } else if (typeof item[prop] == 'number') {
          let propValue = item[prop].toString().toLowerCase();
          let queryValue = query.toLowerCase();
          if (propValue.startsWith(queryValue)) {
            return true;
          }
        }
      }
      return false;
    });

    state.mergeViewItems = listResult;
    state.mergeViewItemsSearch = listResult;
  },
  'SET_STORE_TOGGLE_MERGE_COMPARE_FILTER' (state, filter) {
    let datarows = state.mergeViewItemsSource
    // let check = $( "#input-14").val();
    if($(".compare-merge-input").find("input").val() != ""){
      datarows = state.mergeViewItemsSearch;
    }
    state.filter = filter;
    let query_not_used = filter.query.not_used;
    let query_qualifier = filter.query.qualifier;
    let query = filter.str;
    // let query_one_value = filter.query.one_value;
    // let one_value_check = filter.query_one_value;
    let listResult = [];

    if (!query_not_used && !query_qualifier && query == "") {
      state.mergeViewItems = datarows;
      return;
    }

    if (!query_not_used && !query_qualifier) {
      listResult = datarows;
        listResult = datarows.filter(item =>  {
          if(item.ELEM_VAL != null){
            if(item.ELEM_VAL.toLowerCase() != "not used"){
              return true;
            }
          }
          return false;
        });
    }
    if (query_not_used && query_qualifier) {
      listResult = datarows.filter(item =>  {
        if(item.ELEM_VAL != null){
          if(item.ELEM_VAL.toLowerCase() != "text"){
            return true;
          }
        }
        return false;
      });
    }
    if (query_not_used  && !query_qualifier) {
      listResult = datarows;
    }
    if (!query_not_used  && query_qualifier) {
      listResult = datarows.filter(item =>  {
        if(item.ELEM_VAL != null){
          if(item.ELEM_VAL.toLowerCase() != "text" && item.ELEM_VAL.toLowerCase() != "not used"){
            return true;
          }
        }
        return false;
      });
    }
    state.mergeViewItems = listResult;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
